import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';

class TabList extends React.PureComponent {
    static propTypes = {
        current: PropTypes.number,
        handleTabsChange: PropTypes.func,
    };

    handleMouseOver = e => {
        const index = Number(e.currentTarget.attributes['data-index'].value);
        const { handleTabsChange } = this.props;

        handleTabsChange(index);
    };

    /**
     * 渲染组件
     */
    render() {
        const { current } = this.props;
        const content = ['全部', '财经精选'];

        return (
            <ul className={styles.list}>
                {content.map((item, index) => (
                    <li
                        key={index}
                        data-index={index}
                        className={current === index ? styles.current : ''}
                        onClick={this.handleMouseOver}>
                        {item}
                    </li>
                ))}
            </ul>
        );
    }
}

export default errorBoundary(TabList);
